<div *ngIf="(!isStandingAuthViewPage && !isTransactionViewPage) || isViewForRegularAch; else viewPage"
  id="transaction-details-section">
  <span id="subtitle">{{ pageHeader }}</span>
  <a *ngIf="(createRequestStep$ | async) === 'review' && !isInrFromTable" class="no-print" id="edit-link" (click)="onEditClicked()">Edit</a>

  <!-- TRANSACTION TYPE -->
  <mm-label-group id="reviewPage_transactionTypeLabel" data-testid="reviewPage_transactionTypeLabel"
    [title]="labels.transactionType" [data]="transactionType"></mm-label-group>

    <!-- TRANSFER DIRECTION -->
  <div class="row">
    <mm-label-group id="reviewPage_transferDirectionLabel" [title]="labels.transferDirection"
      [data]="transferDirection | titlecase"></mm-label-group>
  </div>

  <!-- ACCOUNT TO RECEIVE FUNDS -->
  <div class="row">
    <mm-label-group id="reviewPage_sourceOfFundsLabel" data-testid="reviewPage_sourceOfFundsLabel"
      [title]="isAchIn ? labels.sourceOfFunds : labels.accountToReceiveFunds"
      [multilineData]="[nickname, to1, accountName, to2, accountType, abaNumber]"></mm-label-group>
  </div>

  <!-- FREQUENCY/RECURRING FREQUENCY SECTION -->
  <div class="row" *ngIf="isRecurringSetup; else oneTimeFrequency">
    <div class="col">
      <mm-label-group id="reviewPage_frequencyLabel" [title]="labels.frequency" [data]="frequency.recurring"
        data-testid="reviewPage_frequency.recurring"></mm-label-group>
    </div>
    <div class="col" *ngIf="!!frequencyOfOccurrence">
      <mm-label-group id="reviewPage_frequencyOfOccurrenceLabel" [title]="labels.frequencyDescription"
        [data]="frequencyOfOccurrence" data-testid="reviewPage_frequencyOfOccurrence"></mm-label-group>
    </div>
    <div class="col" id="spacer_column_secondCompletionDateLabel" data-testid="spacer_column_secondCompletionDate" *ngIf="secondCompletionDate"></div>
    <div class="col" id="spacer_column_endDateLabel" data-testid="spacer_column_endDate" *ngIf="endDate"></div>
    <div class="col" id="spacer_column_fundsAvailableToTradeLabel" data-testid="spacer_column_fundsAvailableToTradeDate" *ngIf="transferDirection === 'incoming' && step !== 'view'"></div>
  </div>

  <!-- ONETIME FREQUENCY -->
  <ng-template #oneTimeFrequency>
    <div class="row">
      <div class="col">
        <mm-label-group id="reviewPage_frequencyLabel" [title]="labels.frequency" [data]="frequency.onetime"
          data-testid="reviewPage_frequency.onetime"></mm-label-group>
      </div>
    </div>
  </ng-template>

  <!-- DATES ROW -->
  <div class="row">
    <div class="col"> 
      <!-- WITHDRAWAL DATE -->
      <mm-label-group id="reviewPage_expectedWithdrawalDateLabel" data-testid="reviewPage_expectedWithdrawalDate"
        [title]="isRecurringSetup ? labels.nextExpectedWithdrawalDate: labels.expectedWithdrawalDate"
        [data]="(withdrawalDate ? (withdrawalDate | formattedDate) : 'N/A')!"></mm-label-group>
      <div class="label-group">
        <span id="reviewPage_withdrawalDateCopy">{{withdrawalDateCopy}}</span>
      </div>
    </div>

    <!-- COMPLETION DATE -->
    <div class="col" *ngIf="!isView">
      <mm-label-group id="reviewPage_completionDateLabel" data-testid="reviewPage_completionDate"
        [title]="isRecurringSetup ? labels.nextCompletionDate : labels.completionDate" [data]="
          (completionDate ? (completionDate | date : 'MM/dd/yyyy') : 'N/A')!"></mm-label-group>
    </div>

    <!-- SECOND COMPLETION DATE -->
    <div class="col" *ngIf="secondCompletionDate">
      <mm-label-group id="reviewPage_secondCompletionDateLabel" data-testid="reviewPage_secondCompletionDate"
        [title]="labels.secondCompletionDate" [data]="secondCompletionDate"></mm-label-group>
    </div>

    <!-- END DATE -->
    <div class="col" *ngIf="endDate">
      <mm-label-group id="reviewPage_endDateLabel" data-testid="reviewPage_endDate" [title]="labels.endDate"
        [data]="endDate"></mm-label-group>
    </div>

    <!-- FUNDS AVAILABLE TO TRADE -->
    <div *ngIf="transferDirection === 'incoming' && !isViewStep" class="col">
      <mm-label-group id="reviewPage_fundsAvailableToTradeLabel" data-testid="reviewPage_fundsAvailableToTrade"
        [title]="labels.fundsAvailableToTrade"
        [data]="(fundsAvailableToTrade ? (fundsAvailableToTrade | date : 'MM/dd/yyyy') : 'N/A')!"></mm-label-group>
      <div class="label-group">
        <span id="reviewPage_fundsAvailableToTradeCopy">{{fundsAvailableToTradeCopy}}</span>
      </div>
    </div>
  </div>

  <!-- AMOUNTS SECTION -->
  <div *ngIf="isIra && transferDirection === 'outgoing'; else notOutgoingIra" class="row">
    <div class="row">
      <div class="small-col">
        <!-- GROSS AMOUNT -->
        <mm-label-group id="reviewPage_grossAmountLabel" data-testid="reviewPage_grossAmount" [title]="labels.amount"
          [data]="grossAmount"></mm-label-group>

          <!-- FED TAX PERCENT -->
        <mm-label-group id="reviewPage_federalTaxLabel" [title]="labels.federalTax"
          [data]="fedTaxPercent"></mm-label-group>

          <!-- STATE TAX PERCENT -->
        <mm-label-group id="reviewPage_stateTaxLabel" [title]="stateTaxLabel"
          [data]="stateTaxPercent"></mm-label-group>
      </div>
      <div class="small-col" *ngIf="isIra">
        <!-- GROSS/NET -->
        <mm-label-group id="reviewPage_grossNet" data-testid="reviewPage_grossNet" [title]="labels.grossNet"
          [data]="amountType | titlecase"></mm-label-group>

          <!-- FED TAX AMOUNT -->
        <mm-label-group id="reviewPage_federalTaxAmountLabel" data-testid="reviewPage_federalTaxAmount"
          [title]="labels.federalTaxAmount" [data]="fedTaxAmount"></mm-label-group>

          <!-- STATE TAX AMOUNT -->
        <mm-label-group id="reviewPage_stateTaxAmountLabel" data-testid="reviewPage_stateTaxAmount"
          [title]="labels.stateTaxAmount" [data]="stateTaxAmount"></mm-label-group>

          <!-- NET CASH AMOUNT -->
        <mm-label-group id="reviewPage_netAmountLabel" data-testid="reviewPage_netAmount" [title]="labels.netCashAmount"
          [data]="netAmount"></mm-label-group>
      </div>
    </div>
  </div>

  <!-- AMOUNT FOR NON-IRA -->
  <ng-template #notOutgoingIra>
    <div class="row">
      <div class="col">
        <mm-label-group id="reviewPage_amountLabel" data-testid="reviewPage_amount" [title]="labels.amount"
          [data]="amount"></mm-label-group>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="isIra">
    <div class="row">
      <div class="col">
        <div *ngIf="transferDirection === 'incoming'">
          <!-- CONTRIBUTION REASON -->
          <mm-label-group id="reviewPage_contributionReasonLabel" [title]="labels.contributionReason"
            [data]="contributionReason"></mm-label-group>
        </div>
        <!-- DISTRIBUTION REASON -->
        <div *ngIf="transferDirection === 'outgoing'">
          <mm-label-group id="reviewPage_distributionReasonLabel" [title]="labels.distributionReason"
            [data]="distributionReason"></mm-label-group>
        </div>
      </div>
    </div>
    <!-- TAX PARAGRAPH ONE -->
    <div class="row" *ngIf="transferDirection === 'outgoing'">
      <div class="label-group" data-testid="review_Page_taxParagraphOne"
        *ngIf="(createRequestStep$ | async) === 'review'">
        <span id="tax-copy-paragraph-one">{{taxCopyParagraphOne}}</span>
      </div>
    </div>
    <!-- TAX PARAGRAPH TWO -->
    <div class="row" *ngIf="transferDirection === 'outgoing'">
      <div class="label-group" data-testid="checkDetails_taxParagraphTwo"
        *ngIf="(createRequestStep$ | async) === 'review'">
        <span id="tax-copy-paragraph-two">{{taxCopyParagraphTwo}}</span>
      </div>
    </div>
  </ng-template>

  <!-- PTRS FIELDS -->
  <ng-template [ngIf]="isPtrs">
    <div class="row">
      <div class="col">
        <mm-label-group id="reviewPage_trustIncomeLabel" [title]="labels.trustIncomePercent"
          [data]="trustIncomePercent ?? ''"></mm-label-group>

        <mm-label-group *ngIf="!isTransactionViewPage && !!trustTaxCategory" id="reviewPage_trustTaxCategoryLabel" [title]="labels.trustTaxCategory"
          [data]="trustTaxCategory"></mm-label-group>

        <mm-label-group id="reviewPage_trustTaxCodeLabel" [title]="labels.trustTaxCode"
          [data]="trustTaxCode ?? ''"></mm-label-group>

        <mm-label-group id="reviewPage_trustNetTransferAmountLabel" data-testid="reviewPage_trustNetTransferAmount"
          [title]="labels.trustAmount" [data]="trustNetTransferAmount ?? ''"></mm-label-group>
      </div>

      <div class="col">
        <mm-label-group id="reviewPage_trustPrincipalLabel" [title]="labels.trustPrincipalPercent"
          [data]="trustPrincipalPercent ?? ''"></mm-label-group>

        <mm-label-group *ngIf="transferDirection === 'outgoing'" id="reviewPage_trustPaidForLabel"
          [title]="labels.trustPaidFor" [data]="trustPaidFor ?? ''"></mm-label-group>

        <mm-label-group *ngIf="trustComment && isNotEmptyOrNull(trustComment)" id="reviewPage_trustCommentLabel" [title]="labels.trustComment"
          [data]="trustComment"></mm-label-group>
      </div>
    </div>
  </ng-template>

  <mm-banners *ngIf="isPtrs && isViewForRegularAch" [bannerText]="[viewPagePtrsInfoBannerPrimaryText]"
    [boldText]="viewPagePtrsInfoBannerBoldText" [type]="'information'" [showCloseIcon]="false"
    id="viewPage_ptrsDisclaimer" data-testid="viewPage_ptrsDisclaimer"></mm-banners>

</div>
<ng-template #viewPage>
  <mm-non-regular-transaction-details-section-ach></mm-non-regular-transaction-details-section-ach>
</ng-template>
